import api from './api';
import type { Paginated, Stop } from '../types/api';

export async function listStops(activeOnly = true) {
  const params: Record<string, string> = {};
  // activeOnly=false means "the full catalogue incl. inactive" — NOT "only
  // inactive" (which is what ?is_active=false would mean to the filterset).
  if (!activeOnly) params.include_inactive = 'true';

  // Fetch the first page — kept separate from the pagination loop below so
  // TS's control-flow analysis doesn't see `url` and `data` referencing
  // each other and give up (TS7022 "referenced in its own initializer").
  const first = await api.get<Paginated<Stop> | Stop[]>('/stops/', { params });
  const firstData: Paginated<Stop> | Stop[] = first.data;
  if (Array.isArray(firstData)) return firstData;

  // Then walk every subsequent DRF page — the earlier one-shot fetch quietly
  // dropped stops past the default page size (20), so the Routes stop-picker
  // only ever showed the first slice of the catalogue.
  const all: Stop[] = [...firstData.results];
  let next: string | null = firstData.next;
  while (next) {
    const page = await api.get<Paginated<Stop>>(next);
    all.push(...page.data.results);
    next = page.data.next;
  }
  return all;
}

export async function createStop(payload: { name: string; is_active?: boolean }) {
  const { data } = await api.post<Stop>('/stops/', payload);
  return data;
}

export async function updateStop(id: number, payload: Partial<Stop>) {
  const { data } = await api.patch<Stop>(`/stops/${id}/`, payload);
  return data;
}

export async function deleteStop(id: number) {
  await api.delete(`/stops/${id}/`);
}
